import React, { useEffect, useState } from "react";
import { Languages } from "lucide-react";
import { api } from "@/lib/api";

const LANG_LABELS = { fr: "français", en: "anglais", es: "espagnol", pt: "portugais" };

// Texte d'un message de ticket + module de traduction (même moteur que le Fil) : si la langue du message diffère de
// celle du lecteur → `auto` : traduction affichée d'office (équipe), sinon bouton « Traduire » (membre).
export const TicketMessageText = ({ message: m, ticketId, viewerLang, auto = false, enabled = true, t = (k, f) => f, testId }) => {
  const [translated, setTranslated] = useState(null);
  const [busy, setBusy] = useState(false);
  const [show, setShow] = useState(auto);
  const foreign = enabled && !!m.content?.trim() && !!m.language && m.language !== viewerLang;

  const fetchIt = async () => {
    if (translated) return translated;
    setBusy(true);
    try {
      const { data } = await api.post(`/support/tickets/${ticketId}/messages/${m.id}/translate`, { target: viewerLang });
      setTranslated(data.translated || m.content);
      return data.translated;
    } catch { setShow(false); return null; }
    finally { setBusy(false); }
  };
  useEffect(() => {
    if (foreign && auto) fetchIt();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [foreign, auto, m.id]);
  const toggle = async () => { if (!translated) { await fetchIt(); setShow(true); } else setShow((v) => !v); };

  const showTranslated = foreign && show && !!translated;
  return (
    <div data-testid={testId} data-lang={m.language || undefined} data-translated={showTranslated ? 1 : undefined}>
      <div className="whitespace-pre-wrap">{showTranslated ? translated : m.content}</div>
      {foreign && (
        <button type="button" onClick={toggle} disabled={busy} className="mt-1 inline-flex items-center gap-1 text-[11px] font-semibold disabled:opacity-60" style={{ color: "var(--yalola-primary)" }} data-testid={testId ? `${testId}-translate` : undefined}>
          <Languages size={11} />
          {busy ? t("post.translating", "Traduction…")
            : showTranslated ? `${t("support.auto_translated", "Traduit automatiquement")} (${LANG_LABELS[m.language] || m.language}) · ${t("post.see_original", "Voir l'original")}`
            : t("post.translate", "Traduire")}
        </button>
      )}
    </div>
  );
};
